import { idomDBInstance } from "../axios-notes";
import { TOKEN_NAME } from "../config";
import { createState } from "../utils/firebaseToState";
import {
  parseNoteCheckboxFields,
  stringifyArrayObjects,
} from "../utils/helper";
import Cookies from "js-cookie";

export const saveNoteToDatabase = async (note) => {
  const token = Cookies.get(TOKEN_NAME);
  try {
    const response = await idomDBInstance.post(
      "/notes/create",
      stringifyArrayObjects(note),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateNoteToDatabase = async (note) => {
  const token = Cookies.get(TOKEN_NAME);
  try {
    const response = await idomDBInstance.post(
      "/notes/update",
      stringifyArrayObjects(note),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const archiveNoteToDatabase = async (note) => {
  const token = Cookies.get(TOKEN_NAME);
  let data = {
    id: note.id,
    isArchived: true,
  };
  try {
    const response = await idomDBInstance.post(
      "/notes/archive",
      stringifyArrayObjects(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const unArchiveNoteToDatabase = async (note) => {
  const token = Cookies.get(TOKEN_NAME);
  let data = {
    id: note.id,
    isArchived: false,
  };
  try {
    const response = await idomDBInstance.post(
      "/notes/archive",
      stringifyArrayObjects(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const trashNote = async (id) => {
  const token = Cookies.get(TOKEN_NAME);
  let data = {
    id,
    isTrashed: true,
  };
  try {
    const response = await idomDBInstance.post(
      "/notes/move-to-trash",
      stringifyArrayObjects(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const restoreNoteFromDatabase = async (id) => {
  const token = Cookies.get(TOKEN_NAME);
  let data = {
    id,
    isTrashed: false,
  };
  try {
    const response = await idomDBInstance.post(
      "/notes/move-to-trash",
      stringifyArrayObjects(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteNotePremenantlyFromDatabase = async (id) => {
  const token = Cookies.get(TOKEN_NAME);
  let data = {
    id,
  };
  try {
    const response = await idomDBInstance.post(
      "/notes/delete-note-permenantly",
      stringifyArrayObjects(data),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const clearTrash = async () => {
  const token = Cookies.get(TOKEN_NAME);
  try {
    const response = await idomDBInstance.post("/notes/clear-trash", "", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getNotesFromDataBase = async (note) => {
  const token = Cookies.get(TOKEN_NAME);
  try {
    const response = await idomDBInstance.get("/notes", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
